import {
  Card,
  CardContent,
  Stack,
  Typography,
  Link,
  Box,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
// next
import { useRouter } from 'next/router';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Iconify from '../../../components/Iconify';
import {
  WorkHourChart,
} from './'
// utils
import {
  fKrDateAbsoulte,
  fKrDateAbsoulteMD,
} from '../../../utils/formatTime';
// paths
import { PATH_TODO } from '../../../routes/paths';

// ----------------------------------------------------------------------

const Dot = styled('span', {shouldForwardProp: (prop) => prop !== 'dotColor' })(({ dotColor }) => {
  return {
    height: 12,
    width: 12,
    backgroundColor: dotColor,
    borderRadius: '50%',
    display: 'inline-block',
  };
});

const SMDot = styled('span', {shouldForwardProp: (prop) => prop !== 'dotColor' })(({ dotColor }) => {
  return {
    marginLeft: 4,
    height: 8,
    width: 8,
    backgroundColor: dotColor,
    borderRadius: '50%',
    display: 'inline-block',
  };
});

const BlackDot = styled('span')(() => {
  return {
    height: 3,
    width: 3,
    backgroundColor: 'black',
    borderRadius: '50%',
    display: 'inline-block',
  };
});

// ----------------------------------------------------------------------

export default function WorkListCard({ works, matches }) {
  const theme = useTheme();
  const mdUp = useResponsive('up', 'md');
  const router = useRouter();

  const WORK_COLORS = [
    theme.palette.flowkit.blue,
    theme.palette.flowkit.green,
    theme.palette.flowkit.purple,
    theme.palette.flowkit.red,
  ];

  const MATCH_COLORS = [
    theme.palette.grey[600],
    theme.palette.grey[500],
    theme.palette.grey[400],
  ];

  const goTodo = (company) => {
    router.push({
      pathname: PATH_TODO.detail,
      query: {c: company}
    });
  }

  return (
    <>
    {mdUp && (
    <Card
      sx={{
        mb: 4,
        flexDirection: 'column',
        '&:hover': {
          cursor: 'pointer',
          boxShadow: (theme) => theme.customShadows.z24,
        },
      }}
    >
      <CardContent>
        <Typography variant="h6" sx={{ mb: 4 }}>
          현재 사이드잡 {works?.length}건
        </Typography>
        <WorkHourChart works={works} matches={matches} />
        <Stack spacing={6} sx={{ py: 6, px: 1 }}>
        {works?.map((work, index) => (
          <Stack direction="row" alignItems="center" justifyContent="space-between" key={index}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Dot dotColor={WORK_COLORS[index%(WORK_COLORS.length)]} />
              <Stack direction="row" alignItems="center">
                <Link
                  onClick={() => goTodo(work?.company)}
                  variant="subtitle1"
                  sx={{
                    '&:hover': { color: 'primary', cursor: 'pointer' },
                  }}
                >
                  {work?.company_name}
                </Link>
                <Iconify icon="eva:external-link-outline" width={16} height={16} sx={{ ml: 0.5, color: 'text.secondary' }} />
              </Stack>
              <BlackDot />
              <Typography>
                주 {work?.working_hours_per_week}시간
              </Typography>
            </Stack>

            <Typography color="text.secondary">
              {fKrDateAbsoulte(work?.start_date)} ~ {fKrDateAbsoulteMD(work?.end_date)}
            </Typography>
          </Stack>
        ))}
        {matches?.map((match, index) => (
          <Stack direction="row" alignItems="center" spacing={2} key={index}>
            <Dot dotColor={MATCH_COLORS[index%(MATCH_COLORS.length)]} />
            <Stack direction="row" alignItems="center">
              <Typography
                variant="subtitle1"
                sx={{
                  '&:hover': { color: 'primary', cursor: 'pointer' },
                }}
              >
                {match?.company_name}
              </Typography>
            </Stack>
            <BlackDot />
            <Typography>
              주 {match?.working_hours_per_week}시간 논의중
            </Typography>
          </Stack>
        ))}
        </Stack>
      </CardContent>
    </Card>
    )}
    {!mdUp && (
      <Box>
        <Typography variant="h6" sx={{ mb: 4 }}>
          현재 사이드잡 {works?.length}건
        </Typography>
        <WorkHourChart works={works} matches={matches} />
        <Stack spacing={2} sx={{ py: 2, px: 1 }}>
        {works?.map((work, index) => (
          <Card
            key={index}
            onClick={() => goTodo(work?.company)}
          >
            <CardContent sx={{ py: 2, px: 1.5, "&:last-child": { pb: 2 } }}>
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1 }}>
                <SMDot dotColor={WORK_COLORS[index%(WORK_COLORS.length)]} />
                <Stack direction="row" alignItems="center">
                  <Typography variant="subtitle1">
                    {work?.company_name}
                  </Typography>
                  <Iconify icon="eva:external-link-outline" width={16} height={16} sx={{ ml: 0.5, color: 'text.secondary' }} />
                </Stack>
                <BlackDot />
                <Typography>
                  주 {work?.working_hours_per_week}시간
                </Typography>
              </Stack>
              <Typography color="text.secondary" sx={{ ml: 3 }}>
                {fKrDateAbsoulte(work?.start_date)} ~ {fKrDateAbsoulteMD(work?.end_date)}
              </Typography>
            </CardContent>
          </Card>
        ))}
        {matches?.map((match, index) => (
          <Card
            key={index}
          >
            <CardContent sx={{ py: 2, px: 1.5, "&:last-child": { pb: 2 } }}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <SMDot dotColor={MATCH_COLORS[index%(MATCH_COLORS.length)]} />
                  <Typography variant="subtitle1">
                    {match?.company_name}
                  </Typography>
                <BlackDot />
                <Typography>
                  주 {match?.working_hours_per_week}시간 논의중
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        ))}
        </Stack>
      </Box>
    )}
    </>
  )
}